import React from 'react';
import { Button, Form, Input } from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import { DateTimePicker } from 'react-widgets';

export default class Filters extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            startDate: null,
            endDate: null,
            teacherName: null,
            courseName: null
        };

        this.getFilterData = this.getFilterData.bind(this);
        this.getFilterStatisticData = this.getFilterStatisticData.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
    }


    getFilterData() {
        if (!this.state.name && !this.state.startDate && !this.state.endDate) {
            toast('Morate unijeti po čemu želite filtrirati podatke.');
        } else {
            this.props.getFilterData(this.state.name, this.state.startDate, this.state.endDate);
        }
    }

    getFilterStatisticData() {
        if (!this.state.teacherName && !this.state.courseName) {
            toast('Morate unijeti po čemu želite filtrirati podatke.');
        } else {
            this.props.getFilterData(this.state.teacherName, this.state.courseName);
        }
    }

    handleDateChange(name, date) {
        this.setState({
            [name]: date
        });

        if (name === 'endDate' && this.state.startDate && date < this.state.startDate) {
            this.setState({ [name]: null });
            toast('Datum kraja mora biti poslije datuma početka!');
        }
        if (name === 'startDate' && this.state.endDate && date > this.state.endDate) {
            this.setState({ [name]: null });
            toast('Datum početka mora biti prije datuma kraja!');
        }
    }


    render() {
        if (this.props.statistics) {
            return (
                <div>
                    <Form>
                        <Form.Group widths="equal">
                            <Form.Field
                                control={Input}
                                label="Naziv predmeta"
                                value={this.state.courseName}
                                onChange={(e) => this.setState({ courseName: e.target.value })}
                                name="courseName"
                                placeholder="Unesite naziv predmeta"
                            />

                            <Form.Field
                                control={Input}
                                label="Ime profesora"
                                value={this.state.teacherName}
                                onChange={(e) => this.setState({ teacherName: e.target.value })}
                                name="teacherName"
                                placeholder="Unesite ime profesora"
                            />

                        </Form.Group>
                        <Button floated="right" basic="true" color="blue" onClick={this.props.filtersOff}>Odustani
                        </Button>
                        <Button floated="right" color="blue" onClick={this.getFilterStatisticData}>Filtriraj
                        </Button>

                    </Form>
                    <ToastContainer hideProgressBar />

                </div>
            );
        }
        return (
            <div>
                <br />
                <br />
                <Form>
                    <Form.Group widths="equal">
                        <Form.Field
                            control={Input}
                            label="Naziv ispitnog roka"
                            value={this.state.name}
                            onChange={(e) => this.setState({ name: e.target.value })}
                            name="name"
                            placeholder="Unesite naziv ispitnog roka"
                        />

                        <Form.Field>
                            <label>Datum početka</label>
                            <DateTimePicker
                                format="D. M. YYYY."
                                defaultValue={new Date()}
                                time={false}
                                onChange={this.handleDateChange.bind(null, 'startDate')}
                                value={this.state.startDate}
                            />
                        </Form.Field>
                        <Form.Field>
                            <label>Datum kraja</label>
                            <DateTimePicker
                                format="D. M. YYYY."
                                defaultValue={null}
                                time={false}
                                onChange={this.handleDateChange.bind(null, 'endDate')}
                                value={this.state.endDate}
                            />
                        </Form.Field>
                    </Form.Group>
                    <Button floated="right" basic="true" color="blue" onClick={this.props.filtersOff}>Odustani
                    </Button>
                    <Button floated="right" color="blue" onClick={this.getFilterData}>Filtriraj
                    </Button>

                </Form>
                <ToastContainer hideProgressBar />
<br/>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/ExamTerms/Filters.js